import * as React from 'react';
import { MiddlewareSync } from "@sa/rep-common";
import { ComponentProcessingState } from "@sa/rep-react";
import { ComponentTable } from "../components/ComponentTable";
import { SlideContext } from "../Context";
import { REPORT_ID } from '../constants';

export const slide12ComponentMiddleware: MiddlewareSync<ComponentProcessingState> = (input, next) => {
  const { identification, componentContext } = input;
  if (REPORT_ID === identification.reportId) {
    if (identification.componentId === "table") {
      input.component = <ComponentTable context={componentContext as SlideContext}></ComponentTable>;
    }
  }
  return next(input);
};
